import React from 'react';
import {Route} from "react-router";
import {compArr} from "../selectors";
import {compose} from "redux";
import {connect} from "react-redux";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import {withLoading404} from "../../Boilerplate/deferLoaderHoc";
import {setViewPath} from "../../../actions/view";
import MeetingMinuteDetail from "./MeetingMinuteDetail";
import MeetingMinuteEdit from "./MeetingMinuteEdit";
import {getMeetingMinutes} from "../../../actions/meetingMinutes";

class MeetingMinute extends React.PureComponent {
  render() {
    return (
      <div>
        <Route exact path="/projects/:id/meeting-minutes/:meetingMinutesId" component={MeetingMinuteDetail}/>
        <Route path="/projects/:id/meeting-minutes/:meetingMinutesId/edit" component={MeetingMinuteEdit}/>
      </div>
    );
  }
}

const MeetingMinuteBreadcrumb = props => PathBreadcrumbItem({ path: `/projects/${props.match.params.id}/meeting-minutes/`, resource: props.meetingminutes.resource });

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const meetingminutes = state.view.subview.data[props.match.params.meetingMinutesId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'meetingminutes', props.match.params.meetingMinutesId];
      if (!compArr(path, itempath) || loading || !meetingminutes) return { loading: true };
      return { meetingminutes, projectId };
    },
    (dispatch, props) => ({
      preload: () => dispatch(setViewPath(['projects', props.match.params.id, 'meetingminutes', props.match.params.meetingMinutesId])),
      loader: () => dispatch(getMeetingMinutes(props.match.params.id, props.match.params.meetingMinutesId)),
    })),
  withLoading404,
  withBreadcrumbCurried(MeetingMinuteBreadcrumb),
)(MeetingMinute);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinute.js